import { Grid, Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { get, post } from "src/utils/networkUtils";
import Scoreboard from "./Scoreboard";
import EventsList from "./EventsList";
import StandingsTable from "./StandingsTable";
import MvpStatsTable from "./MvpStatsTable";
import GameControls from "./GameControls";
import GameScore from "./GameScore";

export default function SeasonPlayground({ userId, onUpdateStreak }) {
  const [scoreboard, setScoreboard] = useState([]);
  const [season, setSeason] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [gameLoading, setGameLoading] = useState(false);
  const [lineupA, setLineupA] = useState([]);
  const [lineupB, setLineupB] = useState([]);
  const [userA, setUserA] = useState(null);
  const [userB, setUserB] = useState(null);

  const handleGetSeason = useCallback(() => {
    setLoading(true);
    const seasonPromise = get(`/admin/versus/users/${userId}/season`)
      .then(function (response) {
        setSeason(response);
        return response;
      })
      .catch(function (error) {
        console.error("Error fetching season data:", error);
        return null;
      });

    Promise.all([seasonPromise]).finally(() => {
      setLoading(false);
    });
  }, [userId, setLoading, setSeason]);

  useEffect(() => {
    handleGetSeason();
  }, [handleGetSeason]);
  const handleRunGame = () => {
    setGameLoading(true);
    post(`/admin/versus/users/${userId}/season`, {
      versusSeasonId: season.season.versusSeasonId,
    })
      .then(function (response) {
        const scoreboard = response.userALineup.map((player, index) => {
          const opponentCard = response.userBLineup[index];
          return {
            playerA: player?.knownname,
            playerB: opponentCard?.knownname,
            teamA: player?.teamExternalRef,
            teamB: opponentCard?.teamExternalRef,
            scoreA: player?.score,
            scoreB: opponentCard?.score,
            position: player?.position,
          };
        });
        setScoreboard(scoreboard);
        setEvents(response.events);
        setLineupA(response.userALineup);
        setLineupB(response.userBLineup);

        setUserA(response.userA);
        setUserB(response.userB);
        onUpdateStreak();
        console.log("::::Game run successfully::::::");
        handleGetSeason();
      })
      .catch(function (error) {
        console.error("Error fetching versus stats:", error);
      })
      .finally(() => {
        setGameLoading(false);
      });
  };

  const handleCompleteSeason = () => {
    setGameLoading(true);
    post(`/admin/versus/users/${userId}/season-complete`, {
      versusSeasonId: season.season.versusSeasonId,
    })
      .then(function (response) {
        window.location.reload();
      })
      .catch(function (error) {
        console.error("Error fetching versus stats:", error);
      })
      .finally(() => {
        setGameLoading(false);
      });
  };

  return (
    <Grid container spacing={3}>
      {loading ? (
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 8,
            }}
          >
            <CircularProgress size={60} sx={{ mb: 3 }} />
            <Typography variant="h6">Loading season data...</Typography>
          </Box>
        </Grid>
      ) : (
        <>
          <Grid item xs={12} mb={2}>
            {season && (
              <GameControls
                userId={userId}
                onPlayGame={handleRunGame}
                onCompleteSeason={handleCompleteSeason}
                season={season}
                gameLoading={gameLoading}
                handleGetSeason={handleGetSeason}
              />
            )}
          </Grid>
          {gameLoading ? (
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 8,
                }}
              >
                <CircularProgress size={60} sx={{ mb: 3 }} />
                <Typography variant="h6">Processing game...</Typography>
              </Box>
            </Grid>
          ) : (
            <>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8}>
                    <GameScore
                      lineupA={lineupA}
                      lineupB={lineupB}
                      userA={userA}
                      userB={userB}
                    />
                    <Scoreboard data={scoreboard} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    {events && events.length > 0 && (
                      <EventsList events={events} />
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <StandingsTable data={season ? season.standings : []} />
              </Grid>
              {season && season.season && (
                <Grid item xs={12} md={6}>
                  <MvpStatsTable data={season ? season.stats : []} />
                </Grid>
              )}
            </>
          )}
        </>
      )}
    </Grid>
  );
}
